import { StatesModule } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { CompanyStateService } from '../auth/services/company-state.service';
import { SettingsTabsComponent } from './components/settings-tabs/settings-tabs.component';
import { ViewportComponent } from './viewport/viewport.component';
import { UserAddComponent } from './components/user-add/user-add.component';
import { CompanyAddComponent } from './components/company-add/company-add.component';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { CompanyLicensesComponent } from './components/company-licenses/company-licenses.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { SSOSettingsComponent } from './components/sso-settings/sso-settings.component';
import { CompanyAccessService } from './services/company-access.service';
import { IntegrationsComponent } from './components/integrations/integrations.component';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.settings',
      abstract: true,
      component: SettingsTabsComponent,
    },
    {
      name: 'apps.settings.home',
      url: '/settings',
      redirectTo: 'apps.settings.company-details',
    },
    {
      name: 'apps.settings.company-details',
      url: '/company/details',
      component: CompanyDetailsComponent,
      resolve: [
        {
          token: 'companyId',
          deps: [CompanyStateService],
          resolveFn: (companyStateService) => {
            return companyStateService.getSelectedCompanyId();
          },
        },
      ],
    },
    {
      name: 'apps.settings.sso-settings',
      url: '/sso',
      component: SSOSettingsComponent,
    },
    {
      name: 'apps.settings.company-licenses',
      url: '/company/licenses',
      component: CompanyLicensesComponent,
      resolve: [
        {
          token: 'companyLicenses',
          deps: [Transition, CompanyAccessService],
          resolveFn: (transition, companyAccessService) => {
            if (!companyAccessService.accessCompanyLicenses) {
              transition.abort();
              return transition.router.stateService.go(
                'apps.settings.billing.home',
                transition.params(),
              );
            }
          },
        },
      ],
    },
    {
      name: 'apps.settings.integrations',
      url: '/integrations',
      component: IntegrationsComponent,
    },
    {
      name: 'apps.settings.user-list',
      url: '/user/list',
      params: {
        state: '',
      },
      component: UserListComponent,
    },

    {
      name: 'apps.company',
      abstract: true,
      component: ViewportComponent,
    },
    {
      name: 'apps.company.add',
      url: '/company/add',
      component: CompanyAddComponent,
    },

    {
      name: 'apps.user',
      abstract: true,
      component: ViewportComponent,
    },
    {
      name: 'apps.user.add2',
      url: '/users/add',
      redirectTo: 'apps.user.add',
    },
    {
      name: 'apps.user.add',
      url: '/user/add',
      params: {
        state: '',
      },
      component: UserAddComponent,
      resolve: [
        {
          token: 'companyId',
          deps: [CompanyStateService],
          resolveFn: (companyStateService) => {
            return companyStateService.getSelectedCompanyId();
          },
        },
      ],
    },
    {
      name: 'apps.user.details',
      url: '/user/details/:username',
      component: UserDetailsComponent,
      params: {
        username: { squash: true, value: '' },
      },
    },
  ],
};
